import { BaseReducer } from '@identic/api';
import { PatientState, PatientInitialState, PatientActions } from './patient.state';

export function PatientReducer(state: PatientState = PatientInitialState, action: any): PatientState {
  return BaseReducer(state, action, PatientActions);
}
// console.log(`%cPatientReducer::ngOnInit`, 'background:yellow');
